// featureLock.ts — what stays free once the 10-day trial lapses (auth.featuresLocked).
//
// Premium app features (guided meditations, most toolkit exercises) lock behind a
// buy-to-unlock prompt. These exceptions stay free for everyone, always — the
// in-the-moment safety/grounding tools and the roll-the-dice practice. Calm Your
// Body is handled separately (it degrades to the panic route). The self-compassion
// course is a separate track and is never gated.
//
// Toolkit ids live in src/data/toolkit.ts. Adjust this list there as the toolkit
// changes; erring toward keeping grounding/safety tools free.
export const FREE_WHEN_LOCKED_TOOL_IDS: ReadonlySet<string> = new Set([
  'calm', // "Getting calm when trauma is triggered" — grounding / in-the-moment
  'drama', // managing the urge for drama — in-the-moment
  'dice', // roll-the-dice compassion practice
]);

/** True if this toolkit exercise should remain free while features are locked. */
export function isFreeToolWhenLocked(id: string): boolean {
  return FREE_WHEN_LOCKED_TOOL_IDS.has(id);
}

// TRIAL_FULL_LOCK: the self-compassion course's own meditations (the ones its page offers)
// stay open for a lapsed non-member; every other meditation locks.
const SELF_COMPASSION_MEDITATION_TITLES: ReadonlySet<string> = new Set([
  'Loving Kindness',
  'Soothing our suffering',
  'Free and Loving Self',
]);

export function isSelfCompassionMeditation(title: string): boolean {
  return SELF_COMPASSION_MEDITATION_TITLES.has(title);
}
